import StudentGroupComp from "./Chat/StudentGroupComp";
const StdSelectedGroupList = () => {
  const userToken = sessionStorage.getItem("token");

  return <div>{userToken ? <StudentGroupComp /> : "loading..."}</div>;
};

export default StdSelectedGroupList;
